import React from "react";
import { useLocation } from "react-router-dom";
import { Row, Layout, Affix } from "antd";
import { Header } from "../../Components/Header";
import { Outlet } from "react-router-dom";

const { Content } = Layout;

const PageWithSidebar = () => {
  const location = useLocation();

  const isLandingPage =
    location.pathname === "/LandingPage" || location.pathname === "/";
  return (
    <>
      <Affix style={{ zIndex: 1 }}>
        <Header />
      </Affix>

      {isLandingPage && (
        <img
          src="/peshawar-news-bg.jpg"
          alt="Peshawar News Background"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",

            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            objectFit: "cover",
          }}
        />
      )}

      <Row style={{ height: "100%" }}>
        <Content style={{ height: "100%" }}>
          <Outlet />
        </Content>
      </Row>
    </>
  );
};

export default PageWithSidebar;
